import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutWalkSectionConfig } from 'src/environments/environment.interface';
import { AboutWalkCardComponent } from '../about-walk-card/about-walk-card.component';

@Component({
  selector: 'app-about-walk-section',
  standalone: false,
  templateUrl: './about-walk-section.component.html',
  styleUrls: ['./about-walk-section.component.scss']
})
export class AboutWalkSectionComponent {
  @Input() section: AboutWalkSectionConfig | null = null;
}
